import React from "react";

export default class ImportRecordsStepsHeader extends React.Component{
  constructor(props){
    super(props)
  };

  render(){
    return(
      <div>
        <div className="steps">
          <ul className="nav nav-wizard">
            <li className={this.props.step == 'import-file' ? 'active import-file-nav' : 'import-file-nav'}><a href="#" >{I18n.t('file_upload')}</a></li>
            <li className={this.props.step == 'assign-columns' ? 'active assign-columns-nav' : 'assign-columns-nav'}><a href="#" >{I18n.t('file_details')}</a></li>
          </ul>
        </div>
      </div>
    )
  };

};